<template>
    <div class="ma-5">
        <v-data-table
                :headers="headers"
                :items="desserts"
                :height="320"
                :fixed-header="true"
                :search="search"
                class="elevation-3"
        >
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>Cadastro de Fornecedor</v-toolbar-title>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>

                    <v-spacer></v-spacer>

                    <v-text-field class="mr-10"
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Pesquisar"
                        single-line
                        hide-details
                    ></v-text-field>
                    <v-dialog persistent v-model="dialog" max-width="600px">
                        <v-card>
                            <v-card-title>
                                <span class="headline">{{ formTitle }}</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col class="pa-0" cols="12" xs="12">
                                            <v-autocomplete
                                                v-model="editedItem.idcomprador"
                                                :items="selects.compradores.items"
                                                label="Digite o nome do Comprador*"
                                                autofocus
                                                clearable
                                                outlined
                                                color="#042333"
                                                item-text="nome_completo"
                                                item-value="id"
                                                :error-messages="compradorErrors"
                                                @input="$v.editedItem.idcomprador.$touch()"
                                                @blur="$v.editedItem.idcomprador.$touch()"
                                            >
                                            </v-autocomplete>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="close">Sair</v-btn>
                                <v-btn color="blue darken-1" text @click="save">Salvar</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                </v-toolbar>
            </template>

            <template v-slot:item.src_modulo="{ item }">
                <v-icon>{{item.src_modulo}}</v-icon>
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon
                    title="Editar Módulo"
                    class="mr-2"
                    @click="editItem(item)"
                >
                mdi-pencil
                </v-icon>
            </template>

        </v-data-table>
    </div>
</template>
<script>
    import {required} from 'vuelidate/lib/validators'
    import Api from "./../../api/cfg";

    export default {
        props: ['atualizarForn'],

        data: () => ({
            dialog: false,
            search: '',
            headers: [
                {
                    text: 'ID',
                    value: 'id',
                },
                {
                    text: 'Razão Social',
                    align: 'left',
                    value: 'razao_social',
                },
                {
                    text: 'ID Comprador',
                    align: 'left',
                    value: 'idcomprador',
                },
                {
                    text: 'Nome Comprador',
                    align: 'left',
                    value: 'nome_completo',
                },
                {text: 'Ações', value: 'action', sortable: false},
            ],
            desserts: [],
            editedIndex: -1,
            editedItem: {
                idcomprador: '',
                id: '',
            },
            defaultItem: {
                idcomprador: '',
                id: '',

            },
            selects: {
                compradores: {
                    items: [],
                }
            }
        }),

        validations: {
            editedItem: {
                idcomprador: {
                    required,
                },

            }
        },
        
        computed: {
            compradorErrors() {
                const errors = []
                if (!this.$v.editedItem.idcomprador.$dirty) return errors
                !this.$v.editedItem.idcomprador.required && errors.push('Campo Obrigatório.')
                return errors
            },
            formTitle() {
                return this.editedIndex === -1 ? 'Novo Comprador' : 'Editar Comprador'
            },
        },

        watch: {
            dialog(val) {
                val || this.close()
            },

            atualizarForn(){
                this.initialize()
            }
        },

        created() {
            this.initialize()
        },

        methods: {
            initialize() {

                const headers = this.Helpers.iniciarRequisicao();

                Api.getFornecedores(headers)
                    .then(response => {

                        const token = response.data.token;
                        localStorage.setItem('token', token);

                        if (response.status == 200) {

                            this.desserts = response.data.fornecedores;

                        }

                    })
                    .catch(() => {
                        this.Helpers.logout();
                    })


                    Api.getCompradores(headers)
                    .then(response => {

                        const token = response.data.token;
                        localStorage.setItem('token', token);

                        if (response.status == 200) {

                            this.selects.compradores.items = response.data.compradores;

                        }

                    })
                    .catch(() => {
                        this.Helpers.logout();
                    })

                this.$store.dispatch("loading/habilitarLoading", false);

            },

            editItem(item) {
                this.editedIndex = this.desserts.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },

            close() {
                this.dialog = false
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                }, 300)
            },

            save() {

                if (!this.$v.$invalid) {

                    const headers = this.Helpers.iniciarRequisicao();

                    const params = this.editedItem;

                    this.$store.dispatch("loading/addRequisicao",
                        Api.addFornecedor(headers, params)
                            .then(response => {

                                const token = response.data.token;
                                localStorage.setItem('token', token);

                                if (response.status == 200) {

                                    this.initialize();

                                }

                            })
                            .catch(() => {
                                this.Helpers.logout();
                            })
                    )

                    this.close()
                }
            },
        },
    }
</script>
<style scoped>
</style>